import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { I18nModule } from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';

import { CarouselItem } from '@app/ui-components/carousel/types';

@Component({
  selector: 'dp-news-carousel-item',
  imports: [I18nModule, MediaModule, GenericLinkModule],
  templateUrl: './news-carousel-item.component.html',
  styleUrl: './news-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DpNewsCarouselItemComponent {
  item = input<CarouselItem>();
}
